module.exports = __webpack_public_path__ + "img/arag_zahn.93f74b0e.svg";